













































































































































import { listFactory } from '@/main/pages';

import { convertToObjects, Row, EditableStatus } from '@/main/utils/table';
import { Partner } from '@/modules/kartoteka/partner';
import { showAlert } from '@/main/utils/notifications';

import _ from 'lodash';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import DmsEditableTableCell from '#components/dms/layout/EditableTableCell.vue';

import Save from '#components/dms/button/Save.vue';

import {
	CUSTOMER_ID, NAME, SPLIT_PARTIES, SPLIT_PARTY, PARTS, LABOUR, EXTLABOUR, CUSTOMER, PRIMARY_CUSTOMER_ROW_INDEX,
	DEFAULT_SHARE_PERCETAGE, MAX_SHARE_PERCETAGE, DEFAULT, DEALER, DEFAULT_INDEX,
} from './constants';

import { store } from './store/list';

import { apiProvider } from './api';

import { types } from './store/types';
import { ISplitPartyInvoiceDetail, SplitPartyType } from './store/SplitBillingDetails';
import { ZAKAZKA_STAV } from '@/modules/servis/zakazka/constants';
import { number } from '@storybook/addon-knobs';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		DmsEditableTable,
		DmsEditableTableCell,
		'dms-save': Save,
	},
	data() {
		return{
			oemName:'',
			dealerName:'',
			dnp: null as number | null,
			partWarrantyPrice: null as number | null,
			laborWarrantyPrice: null as number | null,
			Mrp: null as number | null,
			warrentyPrice: null as number | null,
			discountedDnp: null as number | null,
			IsWarranty: false as boolean,
			IsGoodwill: false as boolean,
			ItemTypeLabour: LABOUR,
			ItemTypePart: PARTS,
			ItemTypeExtLabour: EXTLABOUR,
			extLaborCostPrice: null as number | null,
			InternalPrice: null as number | null,
			ExternalPrice: null as number | null,
			Saga2Prp: null as boolean | null,
			IsAddCustomerEnable: false as boolean,
			allRowsBilled: false as boolean,
			hasStoredIsBilledStatus: false as boolean,
		};
	},
	mounted() {
		// Hard page refresh issue handle
		if (!this.$route.params?.filter && this.$route.query) {
			const filter = {
				ItemId: +this.$route.query.ItemId,
				ServiceOrderId: +this.$route.query.ServiceOrderId,
				OrderStatus:+this.$route.query.OrderStatus,
				Modified:this.$route.query.Modified,
				Saga2Prp: this.$route.query.Saga2Prp === 'true',
				IsOrderSentToSaga: this.$route.query.IsOrderSentToSaga === 'true',
			} as any;
			this.$route.params.filter = { ...filter, ItemType: this.$route.query.ItemType };
			this.filter = { ...filter, ItemType: this.$route.query.ItemType };
			this.props.filter = filter;
		}
		// Need to call specifically as List page does not have filter intialization method
		this.getDropdownListForInternalSplit();
		this.getSplitPartyNames(+this.$route.query.ServiceOrderId);
		this.getSplitPartyForOrder(+this.$route.query.ServiceOrderId);
		this.getDnp(+this.$route.query.ItemId);
		this.getPartWarrantyPrice(+this.$route.query.ItemId);
		this.getMrp(+this.$route.query.ItemId);
		this.getCostPrice(+this.$route.query.ItemId);
		this.getWarrentyRateLo(+this.$route.query.ServiceOrderId, +this.$route.query.ItemId);
		this.getLaborWarrantyPrice(+this.$route.query.ServiceOrderId, +this.$route.query.ItemId);

		if (!this.localState.pageLoaded) {
			this.getPartyInvoicedDetails(+this.$route.query.ServiceOrderId);
			this.localState.pageLoaded = true;
		}		
		this.checkIfAllRowsBilled();
		
	},
	computed: {
		isItemTypePart(): boolean {
			return this.$route?.query?.ItemType === this.ItemTypePart;
		},
		getPart(): string | (string | null)[] {
			return this.$route?.query?.PartNumber;
		},
		getQuantity(): number {
			return +this.$route.query.Quantity;
		},
		getLabourCode(): string | (string | null)[] {
			return this.$route?.query?.LabourCode;
		},
		getTimeUnit(): number {
			return +this.$route?.query?.TimeUnit;
		},
		getExtQuantity(): number {
			return +this.$route.query.ExteQuantity;
		},
		isExtLabour(): boolean {
			return this.$route?.query?.ItemType === this.ItemTypeExtLabour;
		},
		getExtLabourCode(): string | (string | null)[] {
			return this.$route?.query?.ExtLabourCode;
		},
		getUnitOfMeasurment(): string | (string | null)[] {
			return this.$route?.query?.UnitOfMeasurment;
		},
		isModified(): boolean {
			// If all rows are billed, consider table as not modified
			if (this.allRowsBilled) {
				return false;
			}
			return this.table.isModified();
		},
		mutationsMapper(): Record<string, string> {
			return {
				customer: `${this.storeUri}/${types.mutations.SPLIT_CUSTOMER_LIST_MAPPER}`,
			};
		},
		isTableDataNotPresent(): boolean {
			return !this.table.rows?.length;
		},
		isWarrantyExist(): boolean {
			return this.isTableDataNotPresent || this.isSplitPartyExist(SPLIT_PARTIES.Warranty)
			|| this.isSplitPartyExist(SPLIT_PARTIES.Goodwill)
			|| !this.IsWarranty
			|| (this.filter.IsOrderSentToSaga === true)
			|| this.filter.ItemType === EXTLABOUR;
		},
		isGoodwillExist(): boolean {
			return this.isTableDataNotPresent
			|| this.isSplitPartyExist(SPLIT_PARTIES.Goodwill)
			|| this.isSplitPartyExist(SPLIT_PARTIES.Warranty)
			|| !this.IsGoodwill
			|| (this.filter.IsOrderSentToSaga === true)
			|| this.filter.ItemType === EXTLABOUR;
		},
		isDealerExist(): boolean {
			return this.isTableDataNotPresent || this.isSplitPartyExist(SPLIT_PARTIES.Internal);
		},
		rows(): Row[] {
			return this.table.rows;
		},
	},
	methods: {
		checkIfAllRowsBilled(): void {
			if (this.hasStoredIsBilledStatus === false && this.table.rows?.length > 0) {
				this.allRowsBilled = this.table.rows.every(row => row.cells[this.table.cellNames!.IS_BILLED] === true);
				this.hasStoredIsBilledStatus = true;
			} else {
				this.allRowsBilled = false;
			}
		},
		async getSplitPartyNames(serviceOrderId:number | null){
			const response = await apiProvider.fetchSplitPartyNames(serviceOrderId);
			if(response.data)
			{
				this.oemName=response.data.OemName;
				this.dealerName=response.data.DealerName;
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		async getDropdownListForInternalSplit() {
			const { data } = await apiProvider.getDropdownListForInternalSplit();
			if (data) {
				this.dropdownList.InvoiceChargeTypes = data.Item1;
				this.dropdownList.InvoiceDepartments = data.Item2;
			}
		},
		isSplitPartyExist(identifier: any, isCustomer = false): boolean {
			const tableData = convertToObjects(this.table);
			let isSplitPartyTypeExist = false;
			if (tableData && tableData.length) {
				let searchKey = SPLIT_PARTY;
				if (isCustomer) {
					searchKey = CUSTOMER_ID;
				}
				const splitParty = tableData.find(i => i[searchKey] === identifier);
				if (splitParty) {
					isSplitPartyTypeExist = true;
				} else {
					isSplitPartyTypeExist = false;
				}
			} else {
				isSplitPartyTypeExist = false;
			}
			return isSplitPartyTypeExist;
		},
		async getSplitPartyForOrder(orderId: number) {
			const { data: splitPartyData } = await apiProvider.getSplitPartyForOrder(orderId);
			this.IsWarranty = splitPartyData.IsWarranty;
			this.IsGoodwill = splitPartyData.IsGoodwill;
		},
		async handleSave() {
			// if (this.isPrimaryCustomerInvoicedAndModified()) {
			// 	return;
			// }
			try {
				this.startLoading();
				const sumOfSharePercentage = this.sumOfSharePercentage();
				if (parseFloat(sumOfSharePercentage.toFixed(2)) !== 100) {
					this.showMessage(this.LocalizeChyboveHlasky('SB_Share_Percent_Sum') + sumOfSharePercentage);
					return;
				}
				
				const response = await apiProvider.updateList(convertToObjects(this.table), this.filter.ServiceOrderId, this.filter.ItemId);
				if (response.data) {
					this.refreshPreviousPage = true;
					this.closeClick();
				} else {
					this.showErrorAlert({ message: 'SB_Share_Save' });
				}
			} finally {
				this.endLoading();
			}
		},
		showMessage(message: string) {
			showAlert({
				message,
				options: {
					type: 'error',
				},
			});
		},
		async handleClose() {
			if (this.isModified) {
				if (await this.getConfirmationForModifiedTable()) {
					this.closeClick();
				}
			} else {
				this.closeClick();
			}
		},
		async loadFilter() {
			return Promise.resolve();
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			console.log(`Starting rowSaved at ${new Date().toISOString()}`);
			const customerIdIndex = this.table.cellNames!.CUSTOMER_ID;
			const customerId = newRow.cells[customerIdIndex];
			const vatIndex = this.table.cellNames!.VAT_PERCENT;
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const billingStatusColId = this.table.cellNames!.IS_BILLED;
			const primaryShareRowColId = this.table.cellNames!.idColumn;
			const newRowId = newRow.cells[primaryShareRowColId];
			let secondaryShare = newRow.cells[sharePercentageColId];
			const rowExist = this.table.rows.find(c => c.cells[primaryShareRowColId] === newRowId);
			
			// // If share percent exceeds 100, revert to old share percentage
			// const oldSharePercentage = rowExist ? this.localState.row.cells[sharePercentageColId] : 0;
			// const potentialSum = this.sumOfSharePercentage() + secondaryShare - (rowExist ? oldSharePercentage : 0);
			// if (potentialSum > 100) {
			// 	secondaryShare = oldSharePercentage;
			// 	newRow.cells[sharePercentageColId] = oldSharePercentage;
			// 	this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Percent_LT100') });
			// 	return;
			// }
			
			// if existing or new row has entered 0 split value
			if (secondaryShare <= 0) {
				this.onGridValidationFails(rowExist);
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Zero_Percent') });
				return;
			}
			const splitPartyIndex = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = newRow.cells[splitPartyIndex];
			if (newRow.cells[sharePercentageColId] !== 100 && partyType === SPLIT_PARTIES.Warranty) {
				this.onGridValidationFails(rowExist);
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_WARRANTY_SHARE_VAL') });
				return;
			}
			// get the vat amount for split party and display it on grid
			if(customerId){
				//Only fetch vat percent for newly added row only, if it is existing no need to fetch it again as it is already present in the grid
				if (newRowId < 0 && rowExist === undefined) {
					const { data: vatResult } = await apiProvider.getVatPercent(customerId);
					newRow.cells[vatIndex] = vatResult;
				} 
			}
			else{
				newRow.cells[vatIndex] = 0;
			}

			let splitSum = 0;
			if (rowExist) {
				splitSum = this.sumOfSharePercentage();
			} else {
				splitSum = this.sumOfSharePercentage() + secondaryShare;
			}
			const isPrimaryCutomerBilled = this.table.rows[0].cells[billingStatusColId];
			if(!isPrimaryCutomerBilled) {
				// Get Primary share split value
				const primaryShare = this.table.rows.length ? this.table.rows[primaryShareRowColId].cells[sharePercentageColId] : 0;
				let primaryShareAdjusted = -1;
				if (splitSum !== 100 || (splitSum === 100 && rowExist === undefined)) {
					const preservedSecondaryShare = rowExist ? this.localState.row.cells[sharePercentageColId] : 0;
					if (rowExist && primaryShare > 0) {
						// Calculate primary share split value if existing row getting updated
						primaryShareAdjusted = ((primaryShare + preservedSecondaryShare) - secondaryShare);
					} else if (rowExist && primaryShare === 0 && preservedSecondaryShare > secondaryShare) {
						// Calculate primary share split value if existing row getting update and primary share is 0
						primaryShareAdjusted = (preservedSecondaryShare - secondaryShare);
					} else {
						// Calculate primary share split value if new row getting inserted
						primaryShareAdjusted = this.table.rows.length ? (primaryShare - secondaryShare) : 0;
					}
				}
				// If total share split is not 100 and primary share is value is less than 0
				if (splitSum !== 100 && primaryShareAdjusted < 0) {
					this.onGridValidationFails(rowExist);
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Percent_LT100') });
					return;
				}
				// If existing row getting updated
				if (primaryShareAdjusted >= 0) {
					if (this.table.rows.length) {
						this.updateSplitShareForGridRow(primaryShareRowColId, parseFloat(primaryShareAdjusted.toFixed(2)));
					}
				}
				
				const primaryShareRow = this.table.rows[0];
				const primaryShareRowId = primaryShareRow.cells[primaryShareRowColId];
				this.updateShareAmount(primaryShareRow);
				if(newRowId != primaryShareRowId) {
					this.updateShareAmount(newRow);
				}		
				// If new row getting inserted
				if (newRowId < 0 && rowExist === undefined && primaryShare >= 0 && primaryShareAdjusted >= 0) {
					this.table.rows.push(newRow);
				}
			} else {
				// if(splitSum != MAX_SHARE_PERCETAGE) {
				// 	this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Percent_LT100') });
				// 	return;
				// }
				this.updateShareAmount(newRow);
				// If new row getting inserted
				if (newRowId < 0 && rowExist === undefined) {
					this.table.rows.push(newRow);
				}
			}
			console.log(`Completed rowSaved at ${new Date().toISOString()}`);
			
		},

		validateDiscountPercent(row:Row | undefined): boolean {
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountPercent = row?.cells[discountPercentColId] ?? 0;
			let configuredDiscountLimit : number | undefined;
			if(this.filter.ItemType === PARTS) {
				configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.PartItemPer;
			} else {
				configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.LaborItemPer;
			}
			if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && discountPercent > configuredDiscountLimit) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_EXCEEDS_LIMIT') });
				// Clear both discount fields when exceeding limit
				const discountAmountColId = this.table.cellNames!.DISCOUNT_AMOUNT;
				if (row) {
					row.cells[discountPercentColId] = null;
					row.cells[discountAmountColId] = null;
				}
				return false;
			}
			return true;
		},		

		onGridValidationFails(row: Row | undefined) {
			if (row) {
				this.updateSplitShareForGridRow(this.localState.rowIndex!, this.localState.row.cells[this.table.cellNames!.SHARE_PERCENTAGE]);
				(this.$refs.editableSplitPartyTable as any).$nextTick(() => {
					(this.$refs.editableSplitPartyTable as any).editRow(this.localState.rowIndex, this.localState.row);
				});
			} else {
				setTimeout(() => {
					(this.$refs.editableSplitPartyTable as any).createRow();
				}, 500);
			}
		},
		updateSplitShareForGridRow(rowIndex: number, shareValue: number) {
			this.table.rows[rowIndex].cells[this.table.cellNames!.SHARE_PERCENTAGE] = shareValue;
		},
		onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			// preserving row and its index for validation on edit button click
			this.localState.rowIndex = rowIndex;
			this.localState.row = JSON.parse(JSON.stringify(row));
		},
		updateRow(deletedRowData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row, rowIndex: number }) {
			const deletedShare = this.table.rows[deletedRowData.rowIndex].cells[this.table.cellNames!.SHARE_PERCENTAGE];
			const billingStatusColId = this.table.cellNames!.IS_BILLED;
			const isPrimaryCutomerBilled = this.table.rows[0].cells[billingStatusColId];
			if(!isPrimaryCutomerBilled) {
				this.table.rows[this.table.cellNames!.idColumn].cells[this.table.cellNames!.SHARE_PERCENTAGE] += deletedShare;
				this.updateTableRow(deletedRowData);
				this.updateShareAmount(this.table.rows[0] as Row);
			}
			 else {
				this.updateTableRow(deletedRowData);
			 }
		},
		sumOfSharePercentage() {
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const sumOfSharePercentage = this.table.rows.reduce((total: number, obj: Row) => obj.cells[sharePercentageColId] + total, 0);
			return sumOfSharePercentage;
		},
		calculateShareAmountByPercentage(percentage: number, totalAmount: number) {
			const shareAmount = (percentage / 100) * totalAmount;
			return parseFloat(shareAmount.toFixed(2));
		},
		calculateShareAmountWithVat(shareAmount: number, vatAmount: number) {
			const shareAmountWithVat = ((shareAmount * vatAmount) / 100) + shareAmount;
			return parseFloat(shareAmountWithVat.toFixed(2));
		},
		async updateShareAmount(newRow: Row) {
			const shareAmountColId = this.table.cellNames!.SHARE_AMOUNT;
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const totalAmountColId = this.table.cellNames!.AMOUNT;
			const vatAmountColId = this.table.cellNames!.VAT_PERCENT;
			const shareAmountWithVatColId = this.table.cellNames!.SHARE_AMOUNT_WITH_VAT;
			const variationAmountColId = this.table.cellNames!.VARIATION_AMOUNT;			

			const percentage = newRow.cells[sharePercentageColId];
			let totalAmount = newRow.cells[totalAmountColId];
			const vatPercent = newRow.cells[vatAmountColId];

			const customerIdIndex = this.table.cellNames!.CUSTOMER_ID;
			const customerId = newRow.cells[customerIdIndex];

			const splitPartyIndex = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = newRow.cells[splitPartyIndex];

			//For customer and insurance, calculate Vat on MRP. For Internal, Warrenty & Goodwill calculate Vat on NDP.
			//If part is not having NDP, then use RRP for calculation.
			if((partyType === SPLIT_PARTIES.Warranty || partyType === SPLIT_PARTIES.Goodwill) && this.filter.ItemType === PARTS){
				newRow.cells[totalAmountColId] = this.partWarrantyPrice! > 0 ? this.partWarrantyPrice : totalAmount;
				totalAmount = this.partWarrantyPrice! > 0 ? this.partWarrantyPrice : totalAmount;
			}
			else if( partyType === SPLIT_PARTIES.Internal && this.filter.ItemType === PARTS){
				newRow.cells[totalAmountColId] = this.dnp! > 0 ? this.dnp : totalAmount;
				totalAmount = this.dnp! > 0 ? this.dnp : totalAmount;
			}
			else if((partyType === SPLIT_PARTIES.Warranty || partyType === SPLIT_PARTIES.Goodwill) && this.filter.ItemType === LABOUR){
				newRow.cells[totalAmountColId] = this.laborWarrantyPrice! > 0 ? this.laborWarrantyPrice : totalAmount;
				totalAmount = this.laborWarrantyPrice! > 0 ? this.laborWarrantyPrice : totalAmount;
			}
			else if((partyType === SPLIT_PARTIES.Internal) && this.filter.ItemType === LABOUR){
				newRow.cells[totalAmountColId] = this.InternalPrice! > 0 ? this.InternalPrice : totalAmount;
				totalAmount = this.InternalPrice! > 0 ? this.InternalPrice : totalAmount;
			}
			else if (partyType === SPLIT_PARTIES.Internal && this.filter.ItemType === EXTLABOUR) {
				newRow.cells[totalAmountColId] = this.extLaborCostPrice! > 0 ? this.extLaborCostPrice : totalAmount;
				totalAmount = this.extLaborCostPrice! > 0 ? this.extLaborCostPrice : totalAmount;
			}

			
			let shareAmount = this.calculateShareAmountByPercentage(percentage, totalAmount);			
			newRow.cells[shareAmountColId] = shareAmount;			
			newRow.cells[shareAmountWithVatColId] = this.calculateShareAmountWithVat(shareAmount, vatPercent);
			this.applyDiscountOnRow(newRow);

			//-------------- TODO: WE WILL NEED THIS CODE TO CALCULATE VARIATION FOR REFERENCE DOCUMENE IN FUTURE. -----------
			// let variationAmount = 0;
			// // calculate share amount on RRP for reference document.
			// if(partyType === SPLIT_PARTIES.Warranty || partyType === SPLIT_PARTIES.Goodwill || partyType === SPLIT_PARTIES.Dealer){
			// 	totalAmount = newRow.cells[totalAmountColId];
			// 	const shareAmountOnRrp = this.calculateShareAmountByPercentage(percentage, totalAmount);
			// 	variationAmount = shareAmountOnRrp - shareAmount;
			// }
			// else{
			// 	variationAmount = 0;
			// }
			// newRow.cells[variationAmountColId] = variationAmount;
			//------------ END OF TODO ----------------------------------------------------------------------------------------
		},
		async getDnp(itemId: number ){
			const { data: dnp } = await apiProvider.getDnp(itemId);
			this.dnp = dnp;
		},
		async getPartWarrantyPrice(itemId: number ){
			const { data: partWarrantyPrice } = await apiProvider.getPartWarrantyPrice(itemId);
			this.partWarrantyPrice = partWarrantyPrice;
		},
		async getMrp(itemId: number ){
			const { data: Mrp } = await apiProvider.getMrp(itemId);
			this.Mrp = Mrp;
		},
		async getCostPrice(itemId: number){
			if(this.$route.query.ItemType === EXTLABOUR) {
				const { data: extLaborPrice } = await apiProvider.getExtLaborCostPrice(itemId);
				this.extLaborCostPrice = extLaborPrice;
			}
		},
		async getWarrentyRateLo(orderId: number, itemId: number ){
			const { data: laborHourRates } = await apiProvider.getWarrentyRateLo(orderId, itemId);
			this.warrentyPrice = laborHourRates.WarrentyRate;
			this.InternalPrice = laborHourRates.InternalRate;
			this.ExternalPrice = laborHourRates.ExternalRate;
			this.IsAddCustomerEnable = true;
		},
		async getLaborWarrantyPrice(orderId: number, itemId: number ){
			const { data: laborWarrantyPrice } = await apiProvider.getLaborWarrantyPrice(orderId, itemId);
			this.laborWarrantyPrice = laborWarrantyPrice;
		},
	    calculateAmountWithDiscount(costPrice: number, discountPercent: number) {
			const discountedPrice = costPrice - (costPrice * discountPercent)/100 ;
			return parseFloat(discountedPrice.toFixed(2));
		},
		async addOEMorDealerSplitParty(partyType: string) {
			if (this.isSplitPartyInvoiced(partyType)) {
				return;
			}
			// if (this.table.rows.length) {
			// 	const primaryShare = this.table.rows[this.table.cellNames!.idColumn].cells[this.table.cellNames!.SHARE_PERCENTAGE];
			// 	if (!primaryShare) {
			// 		this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Percent_Max') });
			// 		return;
			// 	}
			// }
			if (partyType === 'Customer' && this.isCustomerExist(this.localState.ZakaznikId)) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Customer_Added') });
				return;
			}
			if (partyType === DEALER && this.table.rows.some((item) => item.cells[this.table.cellNames!.SPLIT_PARTY_ID] === SplitPartyType[SplitPartyType.Internal]
					&& item.cells[this.table.cellNames!.INVOICE_CHARGE_TYPE_ID] === this.localState.InvoiceChargeTypeId
					&& item.cells[this.table.cellNames!.INVOICE_DEPARTMENT_ID] === this.localState.InvoiceDepartmentId)) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_CHARGE_DEPARTMENT_VAL') });
				return;
			}
			// For preserving old sequence index of row after redirection from parter select page.
			this.localState.uniqueRowIndex! -= 1;
			(this.$refs.editableSplitPartyTable as any).insertIdSequenc = this.localState.uniqueRowIndex!;

			const cells = [];
			cells.length = this.table.columns.length;
			cells[this.table.cellNames!.AMOUNT] = this.table.rows[0]?.cells[this.table.cellNames!.AMOUNT] ?? 0;
			cells[this.table.cellNames!.CUSTOMER_ID] = null;
			cells[this.table.cellNames!.SHARE_AMOUNT] = 0;
			cells[this.table.cellNames!.SHARE_PERCENTAGE] = 0;
			cells[this.table.cellNames!.SPLIT_BILLING_ID] = null;
			cells[this.table.cellNames!.SPLIT_PARTY_ID] = null;
			cells[this.table.cellNames!.ITEM_TYPE] = this.filter.ItemType;
			switch (partyType) {
				case 'OemWarranty':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Warranty];
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.oemName;
					cells[this.table.cellNames!.SHARE_PERCENTAGE] = MAX_SHARE_PERCETAGE;
					if(this.filter.ItemType === PARTS){
						cells[this.table.cellNames!.AMOUNT] = this.partWarrantyPrice! > 0 ? this.partWarrantyPrice :0;
					}
					else{
						cells[this.table.cellNames!.AMOUNT] = this.laborWarrantyPrice! > 0 ? this.laborWarrantyPrice :0;
					}
					break;
				case 'OemGoodWill':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Goodwill];
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.oemName;
					if(this.filter.ItemType === PARTS){
						cells[this.table.cellNames!.AMOUNT] = this.partWarrantyPrice! > 0 ? this.partWarrantyPrice :0;
					}
					else{
						cells[this.table.cellNames!.AMOUNT] = this.laborWarrantyPrice! > 0 ? this.laborWarrantyPrice :0;
					}
					break;
				case 'Dealer':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Internal];
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.dealerName;
					if(this.filter.ItemType === PARTS){
						cells[this.table.cellNames!.AMOUNT] = this.dnp! > 0 ? this.dnp :0;
					}
					else if(this.filter.ItemType === LABOUR){
						cells[this.table.cellNames!.AMOUNT] = this.InternalPrice! > 0 ? this.InternalPrice :0;
					}
					else if(this.filter.ItemType === EXTLABOUR){
						cells[this.table.cellNames!.AMOUNT] = this.extLaborCostPrice! > 0 ? this.extLaborCostPrice :0;
					}

					cells[this.table.cellNames!.INVOICE_CHARGE_TYPE_ID] = this.localState.InvoiceChargeTypeId;
					cells[this.table.cellNames!.INVOICE_DEPARTMENT_ID] = this.localState.InvoiceDepartmentId;
					cells[this.table.cellNames!.INVOICE_CHARGE_TYPE] = this.dropdownList.InvoiceChargeTypes.find((item) => item.Value === this.localState.InvoiceChargeTypeId)?.Text;
					cells[this.table.cellNames!.INVOICE_DEPARTMENT] = this.dropdownList.InvoiceDepartments.find((item) => item.Value === this.localState.InvoiceDepartmentId)?.Text;
					if (this.dropdownList.InvoiceChargeTypes.length > DEFAULT_INDEX) {
						this.localState.InvoiceChargeTypeId = this.dropdownList.InvoiceChargeTypes[DEFAULT_INDEX].Value;
					}
					if (this.dropdownList.InvoiceDepartments.length > DEFAULT_INDEX) {
						this.localState.InvoiceDepartmentId = this.dropdownList.InvoiceDepartments[DEFAULT_INDEX].Value;
					}
					break;
				case 'Customer': {
					if (!this.localState.ZakaznikId || this.localState.ZakaznikId === null) {
						return;
					}
					const response = await apiProvider.fetchCustomerType(this.localState.ZakaznikId);

					const { data: isCutomerDealer } = await apiProvider.checkIsCustomerDealerType(this.localState.ZakaznikId);
					const{data : isPrimaryCustomerDealar} = await apiProvider.checkPrimaryCustomerType(this.filter.ServiceOrderId!);
					if (this.filter.ItemType === PARTS) {
						if (isCutomerDealer === true) {
							if(isPrimaryCustomerDealar === true){
								cells[this.table.cellNames!.AMOUNT] = this.dnp ?? 0;
							}
							else if(isPrimaryCustomerDealar === false){
								cells[this.table.cellNames!.AMOUNT] = this.dnp;
							}
							else{
								cells[this.table.cellNames!.AMOUNT] = this.dnp! > 0 ? this.dnp : 0;
							}
						}
						else if(isCutomerDealer=== false && isPrimaryCustomerDealar === false){
                            cells[this.table.cellNames!.AMOUNT] = this.Mrp ?? 0;
						}
						else if(isPrimaryCustomerDealar === true && isCutomerDealer === false){
                        	cells[this.table.cellNames!.AMOUNT] = this.Mrp;
						}
					    else {
							cells[this.table.cellNames!.AMOUNT] = this.Mrp! > 0 ? this.Mrp : 0;
						}
					} else if(this.filter.ItemType === LABOUR) {
						if (isCutomerDealer === true) {
							cells[this.table.cellNames!.AMOUNT] = this.InternalPrice;
						} else {
							cells[this.table.cellNames!.AMOUNT] = this.ExternalPrice;
						}
					}
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = response?.data;
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.localState.ZakaznikIdText;
					cells[this.table.cellNames!.CUSTOMER_ID] = this.localState.ZakaznikId;
					this.localState.ZakaznikId = null;
					this.localState.ZakaznikIdText = null;
					break;
				}
			}
			this.localState.defaultRowModel.cells = cells;
			(this.$refs.editableSplitPartyTable as any).createRow();
		},
		isCustomerExist(customerId: number | null): boolean {
			if (customerId) {
				return this.isTableDataNotPresent || this.isSplitPartyExist(customerId, true);
			}
			return false;
		},
		async getPartyInvoicedDetails(serviceOrderId: number) {
			this.localState.splitPartyInvoiceDetails = [];
			this.startLoading();
			const response = await apiProvider.getPartyInvoicedDetails(serviceOrderId);
			this.endLoading();
			if (response.data) {
				this.localState.splitPartyInvoiceDetails = response.data as ISplitPartyInvoiceDetail[];
			}
		},
		isSplitPartyInvoiced(partyType: string, primaryCustomerId: number | null = null): boolean {
			let splitPartyType: string | null = null;
			let customerId: number | null = null;
			switch (partyType) {
				case 'OemWarranty':
					splitPartyType = SplitPartyType[SplitPartyType.Warranty];
					break;
				case 'OemGoodWill':
					splitPartyType = SplitPartyType[SplitPartyType.Goodwill];
					break;
				case 'Dealer':
					splitPartyType = SplitPartyType[SplitPartyType.Internal];
					break;
				case 'Customer':
					customerId = primaryCustomerId ?? this.localState.ZakaznikId;
					break;
			}
			const partyDetails: ISplitPartyInvoiceDetail | undefined = this.localState.splitPartyInvoiceDetails?.find(x => (x.IsBilled)
				&& (splitPartyType !== null ? x.SplitPartyTypeName === splitPartyType : x.CustomerId === customerId));
			if (primaryCustomerId && partyDetails) {
				const primaryCustomer = this.table?.rows[PRIMARY_CUSTOMER_ROW_INDEX].cells;
				if ((partyDetails.IsBilled && primaryCustomer[this.table.cellNames!.SHARE_PERCENTAGE] !== DEFAULT_SHARE_PERCETAGE)) {
					this.showMessage(`${partyDetails.CustomerName} ${this.LocalizeChyboveHlasky('SB_Primary_Party_Cant_Modifed')}
						${DEFAULT_SHARE_PERCETAGE}.`);
					return true;
				}
			} else if (partyDetails) {
				this.showMessage(`${partyDetails.CustomerName} (${this.LocalizePopisostatni(`PI_${partyDetails.SplitPartyTypeName}`)}) 
					${this.LocalizeChyboveHlasky('SB_Party_Cant_Add')}`);
				this.localState.ZakaznikId = null;
				this.localState.ZakaznikIdText = null;
				return true;
			}
			return false;
		},
		isPrimaryCustomerInvoicedAndModified(): boolean {
			const primaryCustomer = this.table?.rows[PRIMARY_CUSTOMER_ROW_INDEX].cells;
			return this.isSplitPartyInvoiced(CUSTOMER, primaryCustomer[this.table.cellNames!.CUSTOMER_ID]);
		},
		isDiscountReadOnly(row: Row): boolean {
			const splitPartyColId = this.table.cellNames!.SPLIT_PARTY_ID;
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const sharePercentage = row.cells[sharePercentageColId];
			const partyType = row.cells[splitPartyColId];
			return partyType === SPLIT_PARTIES.Internal
				|| partyType === SPLIT_PARTIES.Goodwill
				|| partyType === SPLIT_PARTIES.Warranty
				|| sharePercentage === DEFAULT_SHARE_PERCETAGE;
		},
		isSharePercentageReadOnly(row: Row): boolean {
			// For the first (primary customer) row that is not billed, share percentage is read-only.
			// Only discount amount and discount percentage remain editable.
			const idColId = this.table.cellNames!.idColumn;			
			const firstRow = this.table.rows[PRIMARY_CUSTOMER_ROW_INDEX];
			const isFirstRow = !!firstRow && row.cells[idColId] === firstRow.cells[idColId];			
			return isFirstRow;
		},
		onDiscountPercentChange(value: any, row: Row, columnId: number, updateCol: any): void {
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.table.cellNames!.DISCOUNT_AMOUNT;
			const discountPercent = value;

			if (discountPercent !== null && discountPercent !== undefined && discountPercent !== '') {
				const percentValue = +discountPercent;
				if (percentValue < 0 || percentValue > 100) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
					updateCol(null, discountPercentColId);
					updateCol(null, discountAmountColId);
					return;
				}

				// Check configured discount limit based on item type
				let configuredDiscountLimit : number | undefined;
				if(this.filter.ItemType === PARTS) {
					configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.PartItemPer;
				} else {
					configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.LaborItemPer;
				}

				if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && percentValue > configuredDiscountLimit) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_EXCEEDS_LIMIT') });
					updateCol(null, discountPercentColId);
					updateCol(null, discountAmountColId);
					return;
				}

				// Valid percent entered — set it and clear the amount field
				updateCol(percentValue, discountPercentColId);
				updateCol(null, discountAmountColId);
			}
		},
		onDiscountAmountChange(value: any, row: Row, columnId: number, updateCol: any): void {
			console.log(`onDiscountAmountChange called at ${new Date().toISOString()}`);
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.table.cellNames!.DISCOUNT_AMOUNT;
			const discountAmount = value;

			if (discountAmount !== null && discountAmount !== undefined && discountAmount !== '') {
				const amountValue = +discountAmount;
				if (amountValue < 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
					updateCol(null, discountAmountColId);
					return;
				}
				// Valid amount entered — clear the percent field
				updateCol(null, discountPercentColId);
			}
		},
		applyDiscountOnRow(newRow: Row) {
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.table.cellNames!.DISCOUNT_AMOUNT;
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const splitPartyColId = this.table.cellNames!.SPLIT_PARTY_ID;
			const shareAmountColId = this.table.cellNames!.SHARE_AMOUNT;
			const vatPercentColId = this.table.cellNames!.VAT_PERCENT;
			const shareAmountWithVatColId = this.table.cellNames!.SHARE_AMOUNT_WITH_VAT;

			const partyType = newRow.cells[splitPartyColId];
			const isDiscountApplicable = partyType !== SPLIT_PARTIES.Warranty
				&& partyType !== SPLIT_PARTIES.Goodwill
				&& partyType !== SPLIT_PARTIES.Internal;

			if (!isDiscountApplicable) {
				newRow.cells[discountPercentColId] = null;
				newRow.cells[discountAmountColId] = null;
				return;
			}

			// SHARE_AMOUNT (before discount) is already computed by updateShareAmount.
			// Blur handlers guarantee only one of percent/amount is non-null.
			const sharePercentage = +(newRow.cells[sharePercentageColId] ?? 0);
			const baseShareAmount = +(newRow.cells[shareAmountColId] ?? 0);
			const vatPercent = +(newRow.cells[vatPercentColId] ?? 0);

			// When share gets auto-adjusted to zero, discount must also be zero.
			if (sharePercentage <= 0 || baseShareAmount <= 0) {
				newRow.cells[discountPercentColId] = 0;
				newRow.cells[discountAmountColId] = 0;
				return;
			}

			const enteredPercent = newRow.cells[discountPercentColId];
			const enteredAmount = newRow.cells[discountAmountColId];

			let discountedShareAmount = baseShareAmount;

			if (enteredPercent !== null && enteredPercent !== undefined) {
				// Percent is the active field — derive discount amount
				const pct = +enteredPercent;
				const discountAmount = parseFloat(((baseShareAmount * pct) / 100).toFixed(2));
				discountedShareAmount = baseShareAmount - discountAmount;
				newRow.cells[discountAmountColId] = discountAmount;
			} else if (enteredAmount !== null && enteredAmount !== undefined) {
				// Amount is the active field — derive discount percent
				const amt = +enteredAmount;
				if (amt > baseShareAmount) {
					newRow.cells[discountAmountColId] = null;
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_CANNOT_EXCEED_BASE_AMOUNT') });
					return;
				}
				const discountPercent = baseShareAmount > 0 ? parseFloat(((amt / baseShareAmount) * 100).toFixed(2)) : 0;
				newRow.cells[discountPercentColId] = discountPercent;			
				if(this.validateDiscountPercent(newRow) === false) {
					return;
				}
				discountedShareAmount = baseShareAmount - amt;
			
			}
			// If both are null — no discount, leave share amount as-is

			discountedShareAmount = parseFloat(discountedShareAmount.toFixed(2));
			newRow.cells[shareAmountColId] = discountedShareAmount;
			newRow.cells[shareAmountWithVatColId] = this.calculateShareAmountWithVat(discountedShareAmount, vatPercent);
		},		

		canEditRow(row: Row) {
			//if this is first row and is billed, then share percentage should not be editable
			const splitPartyIndex = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = row.cells[splitPartyIndex];
			const isInvoicedIndex = this.table.cellNames!.IS_BILLED;
			const isInvoiced = row.cells[isInvoicedIndex];
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const sharePercent = row.cells[sharePercentageColId];
			if (sharePercent === 0) {
				return false;
			}
			if ( isInvoiced === true) {
				return false;
			}
			if ((partyType === SPLIT_PARTIES.Warranty || partyType === SPLIT_PARTIES.Goodwill) && (this.filter.IsOrderSentToSaga === true)) {				
				return false;
			}
				return true;
        },
	},
	watch: {
		rows(rows: Row[]) {
			if (!this.localState.deepCopiedTableRows.length && !_.isEqual(this.localState.deepCopiedTableRows, rows)) {
				this.localState.deepCopiedTableRows = JSON.parse(JSON.stringify(this.table.rows)) as Row[];
			}
			this.checkIfAllRowsBilled();
		},
	},
});
